export default "__VITE_ASSET__Cf$nyQEP__"